import Action, { ActionOrders , ActionOrdersFetchError, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import OrderState from '../State/OrderState'

const actionOrdersFetchError = (oldState: OrderState, action: Action): OrderState => {
    return { ...oldState, error: (action as ActionOrdersFetchError).message, loading: false }
}

const actionOrdersFetchLoading = (oldState: OrderState, _action: Action): OrderState => {
    return { ...oldState, loading: true, error: undefined }
}

const actionOrders = (oldState: OrderState, action: Action): OrderState => {
    return { ...oldState, loading: false, error: undefined, data: (action as ActionOrders).list }
}

type Process = (oldState: OrderState, action: Action) => OrderState

export const OrderReducer: Reducer<OrderState, Action> = (state: OrderState = {
    data: [], loading: false, error: undefined
}, action: Action): OrderState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.ORDER_LOADING, actionOrdersFetchLoading)
    actionMap.set(ActionType.ORDER_DATA, actionOrders)
    actionMap.set(ActionType.ORDER_ERROR, actionOrdersFetchError)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}
